import * as Yup from 'yup';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import dayjs from 'dayjs';

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);

// Search Emails validation schema
export const SearchEmailsSchema = Yup.object().shape({
  subjectContains: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters'),
  recipientContains: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters'),
  hourFrom: Yup.string()
    .required('Hour From is a required field')
    .matches(/(1[012]|[0-9]):[0-5][0-9](\\s)?/, 'Accepted format h:mm'),
  hourTo: Yup.string()
    .required('Hour To is a required field')
    .matches(/(1[012]|[0-9]):[0-5][0-9](\\s)?/, 'Accepted format h:mm'),
  dateTo: Yup.string()
    .required('Date To is a required field')
    .test(
      'dateToTest',
      'To date should be same or after than from date',
      function (value) {
        const { dateFrom } = this.parent;

        if (
          value &&
          dateFrom &&
          dayjs(value, 'DD/MM/YYYY')
            .utc()
            .local()
            .isBefore(dayjs(dateFrom, 'DD/MM/YYYY').utc().local())
        ) {
          return false;
        }

        return true;
      }
    ),
  dateFrom: Yup.string()
    .required('Date From is a required field')
    .test(
      'rangeDateTest',
      'From date should within 7 days from to date',
      function (value) {
        const { dateTo } = this.parent;

        if (
          value &&
          dateTo &&
          dayjs(dateTo, 'DD/MM/YYYY')
            .utc()
            .local()
            .diff(dayjs(value, 'DD/MM/YYYY').utc().local(), 'day') > 6
        ) {
          return false;
        }
        return true;
      }
    )
});
